import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { IndexCreatePage } from '@/features/ai/rag/rag-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvel index documentaire. */
export const Route = createFileRoute('/$tenant/projects/$projectId/assistant/new')({
  component: IndexCreateRoute,
});

function IndexCreateRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="assistant"
      crumbs={[{ label: t('nav.items.assistant') }]}
    >
      <IndexCreatePage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
